var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.dialogsARR),function(dialog){return _c('dialog-window',{key:dialog.id,attrs:{"options":dialog,"escapeKeyClose":dialog.escapeKeyClose},on:{"close":_vm.destroyDialog}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }